import React from "react";

type LossProps = React.SVGProps<SVGSVGElement>;

export const Loss = (props: LossProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9923 11.1035H9.49232V10.1035H12.2853L8.49232 6.31052L5.49232 9.31052L2.00732 5.82552L2.71432 5.11852L5.49232 7.89652L8.49232 4.89652L12.9923 9.39652V6.60352H13.9923V10.1035C13.9923 10.655 13.5438 11.1035 12.9923 11.1035Z"
      fill="currentColor"
    />
  </svg>
);
